var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.addDialogVisible,
            title: _vm.params.id ? "编辑策略" : "新增策略",
            width: "50%",
            "modal-append-to-body": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.addDialogVisible = $event
            },
            closed: _vm.handleClose,
          },
        },
        [
          _c(
            "div",
            [
              _c(
                "el-form",
                {
                  ref: "params",
                  attrs: {
                    model: _vm.params,
                    rules: _vm.rules,
                    "label-width": "120px",
                    size: "mini",
                  },
                },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "入口选择：", prop: "code" } },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: { placeholder: "请选择" },
                          model: {
                            value: _vm.params.code,
                            callback: function ($$v) {
                              _vm.$set(_vm.params, "code", $$v)
                            },
                            expression: "params.code",
                          },
                        },
                        _vm._l(_vm.entryScene, function (item) {
                          return _c("el-option", {
                            key: item.value,
                            attrs: { label: item.label, value: item.value },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "描述：", prop: "description" } },
                    [
                      _c("el-input", {
                        attrs: {
                          type: "textarea",
                          "show-word-limit": "",
                          autosize: { minRows: 2, maxRows: 99 },
                          maxlength: "999",
                          placeholder: "请输入描述",
                        },
                        model: {
                          value: _vm.params.description,
                          callback: function ($$v) {
                            _vm.$set(_vm.params, "description", $$v)
                          },
                          expression: "params.description",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "渠道选择：", prop: "channel" } },
                    [
                      _c(
                        "el-radio-group",
                        {
                          model: {
                            value: _vm.params.channel,
                            callback: function ($$v) {
                              _vm.$set(_vm.params, "channel", $$v)
                            },
                            expression: "params.channel",
                          },
                        },
                        [
                          _c("el-radio", { attrs: { label: "0" } }, [
                            _vm._v("全部渠道"),
                          ]),
                          _c("el-radio", { attrs: { label: "1" } }, [
                            _vm._v("指定渠道"),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm.params.channel === "1"
                    ? _c(
                        "el-form-item",
                        { attrs: { label: "" } },
                        [
                          _c("el-input", {
                            attrs: { type: "textarea" },
                            on: {
                              focus: function ($event) {
                                return _vm.handleClick()
                              },
                            },
                            model: {
                              value: _vm.params.appidFilterNames,
                              callback: function ($$v) {
                                _vm.$set(_vm.params, "appidFilterNames", $$v)
                              },
                              expression: "params.appidFilterNames",
                            },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: "协议版本号：",
                        prop: "protocolVersionChoose",
                      },
                    },
                    [
                      _c(
                        "el-radio-group",
                        {
                          model: {
                            value: _vm.params.protocolVersionChoose,
                            callback: function ($$v) {
                              _vm.$set(_vm.params, "protocolVersionChoose", $$v)
                            },
                            expression: "params.protocolVersionChoose",
                          },
                        },
                        [
                          _c("el-radio", { attrs: { label: "0" } }, [
                            _vm._v("全部版本"),
                          ]),
                          _c("el-radio", { attrs: { label: "1" } }, [
                            _vm._v("指定版本"),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm.params.protocolVersionChoose === "1"
                    ? _c(
                        "el-form-item",
                        { attrs: { label: "" } },
                        [
                          _c(
                            "el-select",
                            {
                              attrs: { multiple: "", placeholder: "请选择" },
                              model: {
                                value: _vm.params.protocolVersion,
                                callback: function ($$v) {
                                  _vm.$set(_vm.params, "protocolVersion", $$v)
                                },
                                expression: "params.protocolVersion",
                              },
                            },
                            _vm._l(_vm.protocolVersionList, function (item) {
                              return _c("el-option", {
                                key: item.value,
                                attrs: { label: item.label, value: item.value },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _c(
                    "el-form-item",
                    { attrs: { label: "关联推荐策略：", prop: "tacticsId" } },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: { placeholder: "请选择关联推荐策略" },
                          model: {
                            value: _vm.params.tacticsId,
                            callback: function ($$v) {
                              _vm.$set(_vm.params, "tacticsId", $$v)
                            },
                            expression: "params.tacticsId",
                          },
                        },
                        _vm._l(_vm.strategyList, function (item) {
                          return _c("el-option", {
                            key: item.value,
                            attrs: { label: item.label, value: item.value },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "状态：", prop: "status" } },
                    [
                      _c(
                        "el-radio-group",
                        {
                          model: {
                            value: _vm.params.status,
                            callback: function ($$v) {
                              _vm.$set(_vm.params, "status", $$v)
                            },
                            expression: "params.status",
                          },
                        },
                        [
                          _c("el-radio", { attrs: { label: 1 } }, [
                            _vm._v("上线"),
                          ]),
                          _c("el-radio", { attrs: { label: 0 } }, [
                            _vm._v("下线"),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "备注：", prop: "remark" } },
                    [
                      _c("el-input", {
                        attrs: {
                          type: "textarea",
                          "show-word-limit": "",
                          autosize: { minRows: 2, maxRows: 99 },
                          maxlength: "999",
                          placeholder: "请输入备注",
                        },
                        model: {
                          value: _vm.params.remark,
                          callback: function ($$v) {
                            _vm.$set(_vm.params, "remark", $$v)
                          },
                          expression: "params.remark",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  attrs: { size: "small", type: "primary" },
                  on: { click: _vm.handleSave },
                },
                [_vm._v("保存")]
              ),
              _c(
                "el-button",
                { attrs: { size: "small" }, on: { click: _vm.handleClose } },
                [_vm._v("关闭")]
              ),
            ],
            1
          ),
        ]
      ),
      _c("channel-popups", {
        attrs: {
          isAppendToBody: false,
          modelIsAppendToBody: false,
          "app-id": _vm.params.appidFilterList,
          visible: _vm.showPopups,
        },
        on: {
          "update:visible": function ($event) {
            _vm.showPopups = $event
          },
          comfirm: _vm.handleConfirm,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }